(function paycheckSignControllerDefinition() {
    'use strict';

    angular.module('Paycheck')
        .controller('PaycheckSignController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processCustomerService', 'configViewService', '$q', '$window', 'authExtend', 'profileCertificateService', '$parse',
            function paycheckSignController($filter, $state, $scope, $stateParams, errors, processCustomerService, configViewService, $q, $window, auth, profileCertificateService, $parse) {
                $scope.loading = false;
                $scope.legend = { type: 'warning', message: 'NoCertificateAvailable' }

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.load = function () {
                    $scope.processesSignlegend = 'ProcessesSignlegend';
                    $scope.signAction = 'PaycheckRRHHSign';
                    $scope.signature = {
                        metadataValues: []
                    };

                    $scope.processes = processCustomerService.getSignProcesses();

                    if ($scope.processes.length == 0) {
                        errors.showError('SignNoProcess');
                        $scope.cancel();
                        return;
                    }

                    processCustomerService.setSignProcesses([]);

                    var certificateFilters = {
                        organizationalUnitId: $scope.processes[0].organizationalUnitId,
                        enabled: true,
                        active: true,
                        type: 0, // Empleado
                        signType: 1 // Firma masiva
                    };

                    $q.all([configViewService.getById('CPPPaycheck'), profileCertificateService.get(certificateFilters)]).then(function (result) {
                        var paycheckProcessType = $filter('filter')(result[0].processTypes, { processTypeId: $scope.processes[0].processTypeId }, true)[0];

                        if (!paycheckProcessType) {
                            $scope.signature.metadataValues = metadatas;
                            return;
                        }

                        var metadatas = [];

                        paycheckProcessType.metadatas.forEach(function (signatureMetadata) {
                            if (signatureMetadata.editCriteria && signatureMetadata.systemName !== '_peri' && signatureMetadata.systemName !== '_trec') {
                                var isVisible = true;

                                if (signatureMetadata.systemName === '_motivodisc' ||
                                    signatureMetadata.systemName === '_estrec' ||
                                    signatureMetadata.systemName === '_idCertificado' ||
                                    signatureMetadata.systemName === '_cpassword') {
                                    isVisible = false;
                                }

                                var data = {
                                    idObject: '' + signatureMetadata.metadataId,
                                    metadataId: signatureMetadata.metadataId,
                                    metadataType: signatureMetadata.metadataType.toLowerCase(),
                                    metadataLabel: signatureMetadata.editCriteria.name,
                                    metadataIsRequired: signatureMetadata.editCriteria.isRequired,
                                    metadataIsVisible: isVisible,
                                    metadataReadOnly: !signatureMetadata.editCriteria.isEditable,
                                    metadataEnabled: signatureMetadata.editCriteria.isEditable,
                                    maskOptions: signatureMetadata.maskOptions,
                                    metadataValue: null,
                                    metadataOptions: signatureMetadata.metadataOptionValues,
                                    systemName: signatureMetadata.systemName,
                                    order: signatureMetadata.editCriteria.order
                                }

                                if (signatureMetadata.systemName == '_modFirma') {
                                    data.metadataValue = 'FD';
                                }

                                metadatas.push(data);
                            }
                        });

                        metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        $scope.signature.metadataValues = metadatas;

                        if (result[1].length > 0) {
                            $scope.signature.metadataValues.push($scope.addCertificateMetadata(result[1]));
                        } else {
                            $scope.signNoCertificate = true;
                        }
                    });
                };

                $scope.addCertificateMetadata = function (certificates) {
                    var metadataCertificates = {
                        idObject: '_wcertificate',
                        systemName: '_wcertificate',
                        metadataType: 'radio',
                        metadataLabel: 'Certificado',
                        metadataIsVisible: certificates.length > 1,
                        metadataEnabled: certificates.length > 1,
                        metadataIsRequired: true,
                        metadataValue: undefined,
                        metadataOptions: []
                    };

                    angular.forEach(certificates, function (certificate) {
                        var description = certificate.provider;
                        if (certificate.expirationDate) {
                            description = certificate.provider + ' (' + $filter('date')(certificate.expirationDate, 'dd/MM/yyyy') + ')';
                        }

                        metadataCertificates.metadataOptions.push({
                            id: certificate.id,
                            value: certificate.id,
                            description: description,
                            requirePassword: certificate.requirePassword,
                            supportDisagreement: certificate.supportDisagreement || certificate.provider === 'Encode',
                            action: certificate.massiveSignatureAction
                        });
                    });

                    if (metadataCertificates.metadataOptions.length === 1) {
                        metadataCertificates.metadataValue = metadataCertificates.metadataOptions[0].value;
                        $scope.controlChanged(metadataCertificates);
                    }

                    return metadataCertificates;
                };

                $scope.controlChanged = function (data) {
                    if (data.systemName === '_estrec') {
                        $scope.signature.metadataValues.forEach(function (item) {
                            if (item.systemName === '_motivodisc') {
                                item.metadataReadOnly = data.metadataValue === 'C';
                                item.metadataIsRequired = data.metadataValue !== 'C';
                                item.metadataValue = null;
                            }
                        });
                    }
                };

                $scope.controlChanged = function (metadata) {
                    switch (metadata.systemName) {
                        case '_estrec':
                            $scope.signature.metadataValues.forEach(function (item) {
                                if (item.systemName === '_motivodisc') {
                                    item.metadataReadOnly = metadata.metadataValue === 'C';
                                    item.metadataIsRequired = metadata.metadataValue !== 'C';
                                    item.metadataValue = null;
                                }
                            });

                            break;
                        case '_wcertificate':
                            var selectedOption = $filter('filter')(metadata.metadataOptions, { value: metadata.metadataValue }, true);
                            if (selectedOption.length === 1) {
                                $scope.selectedCertificate = selectedOption[0];

                                $scope.signature.metadataValues.forEach(function (m) {
                                    if (m.systemName === '_cpassword') {
                                        m.metadataIsVisible = selectedOption[0].requirePassword;
                                        m.metadataIsRequired = selectedOption[0].requirePassword;
                                        m.metadataValue = undefined;
                                    }

                                    if (m.systemName === '_idCertificado') {
                                        m.metadataValue = $scope.selectedCertificate.id;
                                    }

                                    if (m.systemName === '_motivodisc' || m.systemName === '_estrec') {
                                        m.metadataIsVisible = $scope.selectedCertificate.supportDisagreement;
                                        m.metadataIsRequired = $scope.selectedCertificate.supportDisagreement;
                                        m.metadataValue = !$scope.selectedCertificate.supportDisagreement && m.systemName === '_estrec' ? 'C' : m.metadataValue;
                                    }
                                });
                            }

                            break;
                        default:
                    }
                };

                $scope.execute = function () {
                    if (!$scope.paycheckSign.$valid) {
                        $scope.paycheckSign.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (!$scope.selectedCertificate.action) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    var method = $parse($scope.selectedCertificate.action);

                    if (!method($scope)) {
                        errors.showWarning('CertificateProviderNotConfigured');
                        return false;
                    }

                    return method($scope)();
                };

                $scope.multipleSignEncode = function () {
                    $scope.loading = true;

                    $scope.processes.forEach(function (process) {
                        $scope.signature.metadataValues.forEach(function (mv) {
                            var metadataFound = $filter('filter')(process.metadataValues, { metadataId: mv.metadataId }, true);

                            if (metadataFound.length === 1) {
                                metadataFound[0].value = mv.metadataValue;
                            } else if (metadataFound.length === 0) {
                                process.metadataValues.push({
                                    metadataId: mv.metadataId,
                                    systemName: mv.systemName,
                                    type: mv.metadataType,
                                    value: mv.metadataValue
                                });
                            }
                        });
                    });

                    return processCustomerService.manualActionBatch({ processes: $scope.processes }).then(function (result) {
                        var success = {
                            data: {
                                key: 'SignatureSucces',
                                value: { processesCount: result, from: $scope.processes.length }
                            }
                        }

                        $scope.loading = false;
                        errors.showSuccess(success);
                        $state.go('paycheck-find');
                    }, function (error) {
                        $scope.loading = false;
                        errors.showError(error);
                    });
                };

                $scope.load();
            }
        ]);
})();
